import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const signup = (email, password) => api.post('/auth/signup', { email, password });
export const login = (email, password) => api.post('/auth/login', { email, password });
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, password) => api.post('/auth/reset-password', { token, password });
export const uploadContract = (formData) => api.post('/analyze/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const getProfile = () => api.get('/users/me');
export const getAnalyses = () => api.get('/users/analyses');
export const getAnalysis = (id) => api.get(`/analyze/${id}`);
export const deleteAnalysis = (id) => api.delete(`/analyze/${id}`);
export const createCheckout = (priceId, tier) => api.post('/payments/create-checkout', { price_id: priceId, tier });
export const createPortalSession = () => api.post('/payments/create-portal-session');
export const acceptDisclaimer = () => api.post('/users/accept-disclaimer');

// Q&A API
export const askQuestion = (analysisId, question) => api.post(`/qa/${analysisId}/ask`, { question });
export const getQuestions = (analysisId) => api.get(`/qa/${analysisId}/questions`);
export const getSuggestedQuestions = (analysisId) => api.get(`/qa/${analysisId}/suggestions`);
export const getQuestionUsage = () => api.get('/qa/usage');

// Download report as PDF
export const downloadPDF = async (id) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_URL}/reports/${id}/pdf`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Download failed');
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `contract-analysis-${id}.pdf`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

// Download report as DOC
export const downloadDOC = async (id) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_URL}/reports/${id}/doc`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Download failed');
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `contract-analysis-${id}.docx`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export default api;
